import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CuocDieuTra {
  name: string;
  api_token: string;
}

export interface CuocDieuTraListInfor {
  errors: unknown;
  video: CuocDieuTra;
  isAuthenticated: boolean;
}

@Module
export default class CuocDieuTraModule
  extends VuexModule
  implements CuocDieuTraListInfor
{
  errors = {};
  video = {} as CuocDieuTra;
  isAuthenticated = !!JwtService.getToken();
  cuocDieuTraListData = [] as any;

  get cuocDieuTras() {
    return this.cuocDieuTraListData;
  }

  @Mutation
  [Mutations.SET_CUOC_DIEU_TRA_LIST](cuocDieuTras) {
    this.cuocDieuTraListData = cuocDieuTras;
  }

  @Action
  [Actions.CUOC_DIEU_TRA_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("cuocdieutras/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.SET_CUOC_DIEU_TRA_LIST, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.FETCH_CUOC_DIEU_TRA_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("cuocdieutras", payload)
        .then((data) => {
          this.context.commit(Mutations.SET_CUOC_DIEU_TRA_LIST, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/cuocdieutras",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.SET_CUOC_DIEU_TRA_LIST, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/cuocdieutras", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.SET_CUOC_DIEU_TRA_LIST, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
